export default "__VITE_ASSET__2uCmcV94_u8wnIvjQZO3Iw__"